import React from 'react'
import {
  FlatButton,
  Menu,
  Popover
} from 'material-ui'
import { CardActions } from 'material-ui/Card'
import ContentFilter from 'material-ui/svg-icons/action/list'
import { browserHistory } from 'react-router'
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert'

const cardActionsStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right',
  padding: '14px 0',
  marginRight: -8
}

const Actions = (props) => (
  <div>
    <CardActions style={cardActionsStyle}>
      <FlatButton onClick={props.handleMoreMenuOpen} icon={<MoreVertIcon />} title='More' />
      <FlatButton onClick={() => browserHistory.push(props.successRedirectPath)} icon={<ContentFilter />} title='Return to list' />
    </CardActions>
    <Popover
      open={props.moreMenuOpen}
      anchorEl={props.moreAnchorEl}
      anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      targetOrigin={{ horizontal: 'left', vertical: 'top' }}
      onRequestClose={props.handleMoreMenuClose}
    >
      <Menu onItemClick={props.handleMoreMenuItemTouchTap}>
        {props.buildMenuItems(props.resource)}
      </Menu>
    </Popover>
  </div>
)

// @ts-ignore
Actions.propTypes = {
  resource: React.PropTypes.object.isRequired,
  successRedirectPath: React.PropTypes.string.isRequired,
  buildMenuItems: React.PropTypes.func.isRequired,
  handleMoreMenuOpen: React.PropTypes.func.isRequired,
  handleMoreMenuClose: React.PropTypes.func.isRequired,
  handleMoreMenuItemTouchTap: React.PropTypes.func.isRequired,
  moreMenuOpen: React.PropTypes.bool,
  moreAnchorEl: React.PropTypes.object
}
export default Actions
